import { ReturnCreationEffect } from './return-creation.effect';
import { ReturnReasonEffect } from './return-reason.effect';

export const effects: any[] = [
  ReturnCreationEffect,
  ReturnReasonEffect,
];
